import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  centerContent: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));